import { Component, ChangeDetectionStrategy } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { FormGroupType } from '../../../../../core/models/form-group-type';
import { ApplicationCreationResponse } from '../../../shared/models/responses/application-creation-response';
import { ApplicationTemplateService } from '../../../shared/services/application-template/application-template.service';
import { ApplicationTemplateExistsRequest } from '../../shared/models/application-template-exists-request';
import { ApplicationTemplateRequest } from '../../shared/models/application-template-form-model';
import { ApplicationTemplateFormService } from '../../shared/services/application-template-form/application-template-form.service';
import { ApplicationTemplateFormDialogComponent } from '../application-template-form-dialog/application-template-form-dialog.component';

@Component({
    selector: 'app-application-template-creation-form',
    templateUrl: `./application-template-creation-form.component.html`,
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [ApplicationTemplateFormDialogComponent],
})
export class ApplicationTemplateCreationFormComponent {
    constructor(
        private readonly applicationTemplateFormService: ApplicationTemplateFormService,
        private readonly applicationTemplateService: ApplicationTemplateService,
        private readonly dialogRef: MatDialogRef<ApplicationTemplateCreationFormComponent>,
    ) {}

    form: FormGroup<FormGroupType<ApplicationTemplateRequest>> =
        this.applicationTemplateFormService.getTemplateForm();

    createTemplate(): void {
        this.applicationTemplateService
            .createTemplate(this.generateRequestObject())
            .subscribe(
                (applicationCreationResponse: ApplicationCreationResponse) => {
                    this.closeDialog(applicationCreationResponse);
                },
            );
    }

    closeDialog(
        applicationCreationResponse: ApplicationCreationResponse | null = null,
    ): void {
        this.dialogRef.close(applicationCreationResponse);
    }

    checkTemplateNameExistence(): void {
        this.applicationTemplateFormService.checkTemplateNameExistence(
            this.form,
            this.generateApplicationTemplateExistsRequest(),
        );
    }

    private generateRequestObject(): ApplicationTemplateRequest {
        const formValue = this.form
            .value as Required<ApplicationTemplateRequest>;

        return formValue;
    }

    private generateApplicationTemplateExistsRequest(): ApplicationTemplateExistsRequest {
        return {
            applicationTemplateId: null,
            name: this.form.controls.name.value!,
        };
    }
}
